var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"segment-records"},[_c('div',{staticClass:"segment-summary"},[_vm._v("共 "+_vm._s(_vm.total)+" 段 · 本页 "+_vm._s(_vm.regularSegments.length)+" 段 · 已隐藏 0 圈分段")]),_c('Table',{attrs:{"size":_vm.size,"border":_vm.border,"columns":_vm.columns,"data":_vm.regularSegments,"loading":_vm.loading,"no-data-text":_vm.noDataText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }